(() => {
  'use strict';

  // 二重読み込み防止
  if (window.__salowinAjaxATCInitialized) return;
  window.__salowinAjaxATCInitialized = true;

  /* ---------------------------
   * Cart count updater
   *  - あなたのテーマは <cart-count> を使っているのでそれを更新する
   *  - ついでに Dawn系の .cart-count-bubble があればそれも更新
   * --------------------------- */
  function updateCartCount(count) {
    const n = Number(count) || 0;

    // <cart-count>（ヘッダー＆ドロワー内など、全部まとめて更新）
    document.querySelectorAll('cart-count').forEach((el) => {
      if (n <= 0) el.setAttribute('hidden', '');
      else el.removeAttribute('hidden');

      el.innerHTML = n < 100 ? String(n) : '<span class="text-sm">99+</span>';

      // aria-label（任意）
      el.setAttribute('aria-label', `カート内の商品数 ${n}`);
    });

    // Dawnなどのバッジが残っている場合の保険
    const bubble = document.querySelector('.cart-count-bubble');
    if (bubble) {
      bubble.hidden = n <= 0;
      const targets = bubble.querySelectorAll(
        '[data-cart-count], span[aria-hidden="true"], .cart-count-bubble__text, span'
      );
      const txt = n < 100 ? String(n) : '99+';
      if (targets.length) targets.forEach((t) => (t.textContent = txt));
      else bubble.textContent = txt;
    }

    // html の cart-has-items（テーマ側が使っていることが多い）も整合
    document.documentElement.classList.toggle('cart-has-items', n > 0);
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    if (!res.ok) throw new Error('Failed to fetch cart');
    return await res.json();
  }

  async function refreshCartCount() {
    const cart = await fetchCart();
    updateCartCount(cart.item_count);
  }

  // 連打・多重発火をまとめて1回にする（blog / wishlist / どこからでも）
  let refreshTimer = 0;
  let refreshInFlight = false;
  function scheduleRefreshCartCount() {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(async () => {
      refreshTimer = 0;
      if (refreshInFlight) return;
      refreshInFlight = true;
      try {
        await refreshCartCount();
      } catch (e) {
        console.error(e);
      } finally {
        refreshInFlight = false;
      }
    }, 80);
  }

  /* ---------------------------
   * Toast
   * --------------------------- */
  let toastTimer;
  function showToast(message) {
    let el = document.getElementById('ajax-atc-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'ajax-atc-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);

      const style = document.createElement('style');
      style.textContent = `
        #ajax-atc-toast{
          position: fixed;
          left: 50%;
          bottom: 24px;
          transform: translateX(-50%) translateY(8px);
          padding: 10px 14px;
          border-radius: 9999px;
          background: rgba(20,20,20,.92);
          color: #fff;
          font-size: 13px;
          line-height: 1;
          opacity: 0;
          pointer-events: none;
          transition: opacity .2s ease, transform .2s ease;
          z-index: 99999;
          box-shadow: 0 10px 25px rgba(0,0,0,.18);
          max-width: min(92vw, 420px);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        #ajax-atc-toast.is-visible{
          opacity: 1;
          transform: translateX(-50%) translateY(0);
        }
      `;
      document.head.appendChild(style);
    }

    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 1800);
  }

  /* ---------------------------
   * 重要：ブログ記事など「各所の独自JS」が /cart/add.js を叩いても
   * 自動で検知してカート件数を更新する（ブログ数十本でもOK）
   * --------------------------- */
  function isCartAddUrl(urlLike) {
    if (!urlLike) return false;
    try {
      const u = new URL(String(urlLike), location.origin);
      return u.pathname === '/cart/add.js' || u.pathname === '/cart/add';
    } catch (_) {
      // 文字列が変でも安全側
      return false;
    }
  }
  function getFetchUrl(input) {
    try {
      if (typeof input === 'string') return input;
      if (input && typeof input === 'object' && typeof input.url === 'string') return input.url; // Request
    } catch (_) {}
    return '';
  }

  // fetch をラップして /cart/add(.js) 成功時に自動更新
  const _fetch = window.fetch;
  if (typeof _fetch === 'function') {
    window.fetch = function (input, init) {
      const url = getFetchUrl(input);
      const isAdd = isCartAddUrl(url);

      const p = _fetch.apply(this, arguments);

      if (isAdd) {
        p.then((res) => {
          if (res && res.ok) scheduleRefreshCartCount();
        }).catch(() => {});
      }
      return p;
    };
  }

  // XHR で /cart/add.js を叩く実装があっても拾えるように保険（任意）
  try {
    const XHR = window.XMLHttpRequest;
    if (XHR && !XHR.__salowinPatched) {
      XHR.__salowinPatched = true;
      const _open = XHR.prototype.open;
      const _send = XHR.prototype.send;

      XHR.prototype.open = function (method, url) {
        this.__salowin_url = url;
        return _open.apply(this, arguments);
      };
      XHR.prototype.send = function () {
        this.addEventListener('load', () => {
          try {
            if (this.status >= 200 && this.status < 300 && isCartAddUrl(this.__salowin_url)) {
              scheduleRefreshCartCount();
            }
          } catch (_) {}
        });
        return _send.apply(this, arguments);
      };
    }
  } catch (_) {}

  /* ---------------------------
   * wishlist-vendor.js が投げる cart:refresh を受けて更新
   * --------------------------- */
  window.addEventListener('cart:refresh', () => {
    scheduleRefreshCartCount();
  });

  /* ---------------------------
   * 商品カード等の /cart/add を「ページ遷移なし」で追加する
   * （data-ajax-atc が付いたフォームだけ対象）
   * --------------------------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    // ★ card-product-featured.liquid 側で付けた目印だけAjax化
    if (!form.matches('form[action="/cart/add"][data-ajax-atc]')) return;

    e.preventDefault();

    const btn = form.querySelector('button[type="submit"], input[type="submit"]');
    if (btn && btn.disabled) return;

    const originalText = btn && 'textContent' in btn ? btn.textContent : null;

    if (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      if (originalText) btn.textContent = '追加中…';
    }

    try {
      const formData = new FormData(form);

      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
        credentials: 'same-origin',
      });

      if (!addRes.ok) {
        let msg = '追加できませんでした';
        try {
          const err = await addRes.json();
          if (err && err.description) msg = err.description;
        } catch (_) {}
        throw new Error(msg);
      }

      showToast('カートに追加されました');

      // 既存互換：イベントも投げる（他のJSが使っていてもOK）
      window.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'ajax-atc' } }));
    } catch (err) {
      console.error(err);
      showToast(err?.message || '追加できませんでした');
    } finally {
      if (btn) {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        if (originalText) btn.textContent = originalText;
      }
    }
  });
})();
